export default __webpack_public_path__ + "static/media/gnome-session-reboot-svgrepo-com 1.4ed3c8a3.svg";